import "./App.css";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import RouterBox from "../router/Router";

const AppTheme = {
  palette: {
    primary: {
      main: "#007fff",
    },
    secondary: {
      main: "#f44336",
    },
  },
  typography: {
    fontFamily: [
      "Neo Sans Regular",
      "Poppins",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
};

const theme = createMuiTheme(AppTheme);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <RouterBox />
      </div>
    </ThemeProvider>
  );
}

export default App;
